<template>
  <div class="flex" style="position: relative;">
    <Goback :title="'返回'" style="position: absolute;left: 20%;top:5%;z-index: 10;"></Goback>
    <Overview :batteryInfo="batteryInfo" style="position: absolute;left: 0px;top: 0px;z-index: 10;"/>
    <batteryBox v-show="showBatteryBox" @changeParentShow="changeParentShow"/>
    <batteryBag v-show="!showBatteryBox" @changeParentShow="changeParentShow"/>
    <div class="flex flex-direction batteryBoxR" style="position: absolute;right: 0px;top: 0px;">
      <SiteType :batteryInfo="batteryInfo"/>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/batteryBox/overview.vue";
import batteryBox from "@/views/batteryBox/batteryBox";
import batteryBag from "@/views/batteryBox/batteryBag";

import SiteType from "@/views/batteryBox/siteType.vue";

import { batteryBoxLeft } from '@/api/batteryBox/left';

export default {
  data () {
    return {
      batteryInfo:{},
      showBatteryBox:true,//显示电池箱
    };
  },
  components: {
    Overview,
    batteryBox,
    SiteType,
    batteryBag,
    Goback
  },
  props: {
    
  },
  watch: {
    
  },
  mounted () {
    // 0  乘用车  1 商用车
    this.showBatteryBox = this.$route.query.vehicleClassification*1===1?true:false;
  },
  methods: {
    getData(data){
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>